const initialState = {
    isOpen: false,
    isActive: false,
    newMobile: '',
    mobile: '', 
    code: '', 
    codeErr: '',
    timerTime: 0,
};
const modalEditMobileVerifyOne = (state = initialState, action) => {
    switch (action.type) {
        case 'CHANGE_DATA_MODAL_EDIT_MOBILE_VERIFY_ONE':
            return {...state, [action.name]: action.value};
        default:
            return state;
    }
};

export default modalEditMobileVerifyOne;
